/*
 * @Author: zhouyan
 * @Date: 2025-06-04 14:45:26
 * @LastEditors: zhouyan
 * @LastEditTime: 2025-06-18 11:37:42
 * @Description: 
 * 
 * Copyright (c) 2025 by 重庆大学电子音像出版社有限公司, All Rights Reserved. 
 */
/*
 * @Author: zhouyan
 * @Date: 2025-06-04 14:45:26
 * @LastEditors: zhouyan
 * @LastEditTime: 2025-06-04 15:43:46
 * @Description: 
 * 
 * Copyright (c) 2025 by 重庆大学电子音像出版社有限公司, All Rights Reserved. 
 */
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'


const routes = [  
  {
    path: '/download',
    name: 'downloadList',
    component: () => import('../views/download.vue'),
    meta: { title: '下载专区' }
  },
  
  {
    path: '/production/collect/:entryId?',
    name: 'collect',
    component: () => import('../views/production/collect.vue'),
    meta: { title: '征集作品' }
  },
  {
    path: '/production/collect2',
    name: 'collect2',
    component: () => import('../views/production/collect2.vue'),
    meta: { title: '征集作品' }
  },
  {
    path: '/production/myCollectList',
    name: 'myCollectList',
    component: () => import('../views/production/myCollectList.vue'),
    meta: { title: '我的作品' }
  },
  {
    path: '/production/myCollectList2',
    name: 'myCollectList2',
    component: () => import('../views/production/myCollectList2.vue'),
    meta: { title: '我的作品' }
  },
  {
    path: '/production/view',
    name: 'productionView',
    component: () => import('../views/production/view.vue'),
    meta: { title: '作品预览' }
  },
  {
    path: '/user/login',
    name: 'useLogin',
    component: () => import('../views/user/login.vue'),
    meta: { title: '用户登录|注册' }
  },
  {
    path: '/user/register',
    name: 'userRegister',
    component: () => import('../views/user/register.vue'),
    meta: { title: '用户注册' }
  },
  {
    path: '/user/info',
    name: 'useinfo',
    component: () => import('../views/user/info.vue'),
    meta: { title: '用户信息' }
  },

  {
    path: '/review/index',
    name: 'reviewIndex',
    component: () => import('../views/review/index.vue'),   
    meta: { title: '作品评审' }
  },
  {
    path: '/review/assess',
    name: 'reviewAssess',
    component: () => import('../views/review/assess.vue'),   
    meta: { title: '作品预览' }
  },
  

  
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '第六届特教教师信息技术应用能力展示与交流活动征集' }
  },
  

 
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { title: '页面未找到' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  if (to.query.token) {
    authStore.setToken(to.query.token)
    console.log(to.query.token)
    next({ ...to, query: {} })
    return
  }
  document.title = to.meta.title || '中国教育学会特殊教育分会 - 第六届特教教师信息技术应用能力展示与交流活动征集'
  next()
})

export default router